import { API } from 'services';

export function getMe() {
  return API({
    endpoint: '/user/me',
  });
}

export function getTeamMembers(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/user/team?${queryParams}`,
  });
}

export function getClients(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/user/clients?${queryParams}`,
  });
}

export function getClientsProvider(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/user/clients/provider?${queryParams}`,
  });
}

export function getUser({ id, ...params }) {
  return API({
    endpoint: `/user/profile/${id}`,
    ...params
  });
}

export function updateMe({ ...params }) {
  return API({
    method: 'PUT',
    endpoint: '/user/me',
    ...params
  });
}

export function updateUser({ id, ...params }) {
  return API({
    method: 'PUT',
    endpoint: `/user/profile/${id}`,
    ...params
  });
}

export function deleteFile({ key, ...params }) {
  return API({
    method: 'DELETE',
    endpoint: `/user/profile/file/${key}`,
    ...params
  });
}

export function uploadFile({ id, ...params }) {
  return API({
    method: 'POST',
    endpoint: `/user/profile/${id}/file`,
    ...params
  });
}
